module.exports = __webpack_public_path__ + "media/images/lb/142-6dbfcf2c71b6ba3af6004b698082f73a.svg";